import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {apiQuery} from "../../utils/AppConfig";
import {Response} from "../../types/response/Response";
import {CityDTO} from "../../types/city/CityDTO";

export const cityApi = createApi({
    reducerPath: 'cityUrl',
    baseQuery: apiQuery,
    tagTypes: ['cityUrl'],
    endpoints: builder => ({
        getCities: builder.query<Response<CityDTO[]>, void>({
            query: () => ({
                url: `/cities`,
                method: 'GET'
            }),
            providesTags: ['cityUrl']
        })
    })
})

export const {
    useGetCitiesQuery
} = cityApi